import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBitbucketComponent } from './simple-icons-bitbucket.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBitbucketComponent ],
    exports:      [ SimpleIconsBitbucketComponent ],
    bootstrap:    []
})
export class SimpleIconsBitbucketModule {}
